/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: CommesseIsp.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Modules/CommesseIsp.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 28/07/26, 10:43;
 *  Updated at: 28/07/26, 10:43;
 *  ```
 */

import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {DateToString, PrimoDelMeseString, UltimoDelMeseString} from "../Utility/DateUtility";
import {CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {FieldViewerComponent} from "../../app/shared/field-viewer/field-viewer.component";
import {GetFromLocalStorage} from "../Utility/Utility";

var States =    {id: "RA", label: "Commesse", capacita: [], tipo:"R", module: "Rma", restRoute: '/task/task/commesse' ,SubFilter: [
      {id: "DAP", label: "Da Aprire", capacita: ["menu-commesse-daaprire"], module: undefined},
      {id: "DP", label: "Da pianificare", capacita: ["menu-commesse-dapianificare"], module: undefined},
      {id: "DA", label: "Da approvare", capacita: ["menu-commesse-daapprovare"], module: undefined},
      {id: "DAc", label: "Da accettare", capacita: ["menu-commesse-daaccettare"], module: undefined},
      {id: "IC", label: "In corso", capacita: ["menu-commesse-incorso"], module: undefined, },
      {id: "DC", label: "Da chiudere", capacita: ["menu-commesse-dachiudere"], module: undefined},
      {id: "B", label: "Bloccate", capacita: ["menu-commesse-bloccate"], module: undefined},
      {id: "C", label:  "Chiuse", capacita: ["menu-commesse-chiuse"], module: undefined},
      {id: "DF", label:  "Da Fatturare", capacita: ["menu-fatture"], module: undefined},
      {id: "F", label:  "Da Incassare", capacita: ["menu-fatture"], module: undefined},
      {id: "TT", label:  "Tutte", capacita: ["menu-commesse-tutte"], module: undefined},
    ]};


var ListTableHeaderField=[
  {nome: "Titolo", oggetti: ["type", "CodiceCommessa"],type: 'replace', replacement: [{original: 'C', replace:'CRM'}, {original: 'S', replace:'Scadenza'}, {original: 'R', replace:''},{original: 'W', replace:'Visita'},{original: 'WL', replace:'Contatore'},{original: 'Z', replace:'Attività Laboratorio'}], color:[{colore: 'Colore', fieldexist:'id'}] },
  {nome: "Stato", oggetti: ['Stato'],  filtertype: ['TT']},
  {nome: "Ragione Sociale", oggetti: ['Esercente'],},
  {nome: "Codice Cliente", oggetti: ['CodiceCliente'],  filtertype: ['F','DF']},
  {nome: "Luogo di Intervento", oggetti:['Luogo'], filternottype: ['DF','F']},
  {nome: "Data Impegno", oggetti: ['DataImpegno'], inputType:'date', filternottype: ['DF','F', 'DC'] },
  {nome: "Data Chiusura Tecnico", inputType: 'date', oggetti:['DataChiusuraTecnico'], filtertype: ['DC'] }, // !! MANCA
  {oggetti:['PrimaVerificaEntro'], nome: "Prima Verifica Entro", inputType: 'date',  filternottype: ['DF','F'] },
  {nome: "Tot. Commessa", oggetti: ['TotaleCommessa'],  inputType: 'number',  filtertype: ['DF','F'] },
  {nome: "Tot. Fatturato", oggetti: ['TotaleFattura'],  inputType: 'number', filtertype: ['DF','F']},
  {nome: "Tot. Pagato", oggetti: ['TotalePagato'],  inputType: 'number', filtertype: ['DF','F']},
  {nome: "Data Fattura", oggetti: ['DataFattura'], inputType: 'date', filtertype: ['F',"TT"]},
  {nome: "Scadenza Pagamento", oggetti: ['DataScadenza'], inputType: 'date', filtertype: ['F']},
  {nome: "Fattura N.", oggetti: ['numeroFattura'], filtertype: ['F']},
  {nome: "Ispettore", oggetti:['Ispettore'], filternottype: ['DA','DP','DAP']},
  /*{nome: "Tipologia", oggetti: ['type'], type: 'replace', replacement: [{original: 'C', replace:'CRM'}, {original: 'S', replace:'Scadenza'}, {original: 'R', replace:'Attività'},{original: 'W', replace:'Visita'}]},*/
];

var Mesi: string[] = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre', 'Tutti'
]

var Filters =  [
  CampoAggiuntivo.SingleDropdown("Cliente", "cliente", "/anagrafica/clienti/list", "nominativo",{
    url:'/anagrafica/clienti/list',
    parameter: [{nome:"page", value: 1}, {nome:"size", value: 20}, {nome:"nome", search:true}],
    responseHasData: true,
  }, 'col-lg-3', ()=>true, {
    searchPlaceholderText: "Cerca per caricare gli altri risultati",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  }),
  CampoAggiuntivo.SingleDropdown("Ispettore", "persona", "/anagrafica/persone/list", "fullName",{
    url:'/anagrafica/persone/list',
    parameter: [{nome:"page", value: 1}, {nome:"size", value: 20}, {nome:"nome", search:true}],
    responseHasData: true,
  }, 'col-lg-3', ()=>true, {
    searchPlaceholderText: "Cerca per caricare gli altri risultati",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  }),
  CampoAggiuntivo.TextField("Codice", "codice"),
  CampoAggiuntivo.InputField("Tutti", 'tutti', 'checkbox', 'col-lg-1', {
    hideif:{func:isTuttiVisible},
    // titledivClass: 'input-group-prepend',
    // titleClass: 'input-group-text',
  }),
  CampoAggiuntivo.Html('', (x)=>{
    return `<div  class="${ x.mese == 14 ?  'btn btn-outline-info  p-2': 'btn btn-dark  p-2'}">
        <span class="mx-1  font-weight-bold">Scadute</span>
      </div>`

  }, ()=>true, {
    prevDivClass: 'col-lg-12',
    onClick:(filtro, component: FieldViewerComponent)=>{
      filtro.mese = 14;
      filtro.inizio = "2020-01-01";
      filtro.fine = DateToString(new Date());
      filtro.chiuse = false;
      component.ChangeHandler('',filtro, {},null);
    }
  }),
  ...Mesi.map((mese, idx)=>{
    return CampoAggiuntivo.Html('', (x)=>{
      return `<div  class="${ x.mese == idx+1 ?  'btn btn-outline-info  p-2': 'btn btn-dark  p-2'}">
        <span class="mx-1  font-weight-bold">${mese}</span>
      </div>`

    }, ()=>true, {

      onClick:(filtro, component: FieldViewerComponent)=>{

        const isTutti = idx == 12;
        function filteredYear(){return ((filtro.anno?.toString() ?? '')?.length ? Number(filtro.anno) : null);}
        filtro.anno = isTutti ? filteredYear()?? null : (filteredYear() ?? (new Date()).getFullYear());
      //  var filteredYear = filtro.anno?.length ? Number(filtro.anno) : null;
        var inizio = `${filteredYear()?? (new Date()).getFullYear()}-${(!isTutti ? (idx+1) : 1).toString().padStart(2, '0')}-01`

        // const data = new Date();
        // data.setMonth(!isTutti ? idx : 0);
        // data.setFullYear(filteredYear()?? (new Date()).getFullYear());
        // data.setDate(1);
        const DataFine = new Date();
        DataFine.setMonth(!isTutti ? idx+1: 11);
        DataFine.setFullYear((idx != 11 ? filteredYear() : filteredYear() +1)?? (new Date()).getFullYear());
        DataFine.setDate(!isTutti ? 0 : 31);

        console.log(inizio, DataFine);

        filtro.mese = idx+1;
        filtro.inizio = inizio;
        filtro.fine = DateToString(DataFine);
        filtro.periodo = isTutti ? !!filteredYear() : true;
        filtro.chiuse = null;
        component.ChangeHandler('',filtro, {},null);
      }
    })
  }),

  CampoAggiuntivo.TextField("Anno", "anno",'col-lg-3',{  titledivClass: 'input-group-prepend',
    titleClass: 'input-group-text',
    OnChangeFunc: (filtro)=>{
    var meseFine = filtro.fine? filtro.fine.split('-')[1] : '12'
      filtro.anno = filtro.anno?.length ? Number(filtro.anno) : null;
      if(!filtro.anno) {

        filtro.periodo = false;
        filtro.inizio = undefined
        filtro.fine = undefined;
        filtro.mese = 13;
        return;
      }
      filtro.periodo = true;
      filtro.inizio = `${filtro.anno}-${filtro.inizio? filtro.inizio.split('-')[1] : '01'}-01`
      var ggfine = ['11', '04', '06', '09', '02'].includes(meseFine) ? (meseFine == '02' ? '28' :'30' ) : '31'
      filtro.fine = `${filtro.anno}-${meseFine}-${ggfine}`

    }
  }),

];


function getID(Type: string){
  return `commesse_isp_${Type}`;
}
function getTitle(Type: string){
  return States.SubFilter.find(x=>x.id == Type)?.label ?? '';
}
function isTuttiVisible () {
  const _permittedRoles: string[] = ['RT', 'Amministrazione', 'SP', 'Commerciale', 'All', 'SC', 'SA']
  const _capacita: string[] = ['rt']
  var visible: boolean = false;

  var currentUserValue = GetFromLocalStorage('currentUser');

  _permittedRoles.forEach(role=>{
    var Ra = currentUserValue?.ruoliAccessoObject?.find(x => x.ruolo?.toUpperCase() == role.toUpperCase() || x.id == role);
    var R = currentUserValue?.ruoliObject?.find(x => (typeof x.id == 'string' && x.id?.toUpperCase() == role.toUpperCase()) || x.id == role || x.ruolo?.toUpperCase() == role.toUpperCase());
    var c = currentUserValue?.capacita?.find(x => (typeof x == 'string' && x?.toUpperCase() == role.toUpperCase()) || x== role);
    visible = visible || Ra != undefined || R != undefined || c != undefined;
  })
  return visible ;
}
function CommesseIsp(Type: string) {

  var selType = States.SubFilter.find(x=>x.id == Type);
  var OBJ: OggettoConfig = {
    Id: getID(Type),
    RestRoute: '/task/task',
    ListResponseHasData:true,
    PrintHeaders: [],
    listRoute: 'commesse',
    listTitle: getTitle(Type),
    ListDefaultFilter:{periodo: false,  mese: 13, stato:Type, tutti:isTuttiVisible() },
    OpenTask:true,
    Filters:Filters,
    badges: [
      { nome: '', field: 'total', color: 'red' },

    ],
    Headers:[
      ...ListTableHeaderField.filter(x=>(!x.filtertype || x.filtertype.includes(Type)) && (!x.filternottype || !x.filternottype.includes(Type)))
    ],

  }
  return OBJ;
}


export var CommesseIspEnv = () => {
  var env: any = {
    men:[{
      module: "Rma",
      title: 'Commesse Isp',
      icon: "mdi mdi-calendar-multiple-check",//mdi-calendar-multiple-check //mdi-engine-outline
      class: "has-arrow",
      path: ``,
      submenu: [
        ...States.SubFilter.map(selType=>{
          return {
            module: "Rma",
            path: `/shared/dynamiclist/${getID(selType.id)}`,
            title: selType.label,
            icon: "mdi mdi-calendar",
            capacita: selType.capacita,
          }
        })
      ],
      capacita: [
        ...States.SubFilter.reduce((prev, cur)=> [...prev, ...cur.capacita],[])
      ]
    },],
    Modules: {
      "commesse_isp": true
    },
    Cruds: [...States.SubFilter.map(x=>CommesseIsp(x.id))],

  }
  return env;

}
